import React from 'react';
import { validateColumns, EXPECTED_COLUMNS } from './columnValidation';

interface ColumnValidationCardProps {
    data: Record<string, any>[];
}

const ColumnValidationCard: React.FC<ColumnValidationCardProps> = ({ data }) => {
    const columnValidation = validateColumns(data);

    return (
        <div className="column-validation-card">
            <div className="validation-header">
                {columnValidation.isValid ? (
                    <>
                        <span className="validation-icon success">✓</span>
                        <h3>Spaltenvalidierung erfolgreich</h3>
                    </>
                ) : (
                    <>
                        <span className="validation-icon warning">⚠</span>
                        <h3>Spaltenvalidierung: Abweichungen gefunden</h3>
                    </>
                )}
            </div>
            {!columnValidation.isValid && (
                <div className="validation-details">
                    {columnValidation.missingColumns.length > 0 && (
                        <div className="validation-section">
                            <h4>Fehlende Spalten:</h4>
                            <ul>
                                {columnValidation.missingColumns.map((col, idx) => (
                                    <li key={idx} className="missing-column">{col}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {columnValidation.extraColumns.length > 0 && (
                        <div className="validation-section">
                            <h4>Zusätzliche Spalten:</h4>
                            <ul>
                                {columnValidation.extraColumns.map((col, idx) => (
                                    <li key={idx} className="extra-column">{col}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
            {columnValidation.isValid && data.length > 0 && (
                <div className="validation-details">
                    <p>Alle erwarteten Spalten sind vorhanden ({EXPECTED_COLUMNS.length} Spalten)</p>
                </div>
            )}
        </div>
    );
};

export default ColumnValidationCard;
